import React, { createContext, useContext, useState, useEffect } from 'react';
import baseURL from '../components/url';
import { setClienteToken, clearClienteToken, clienteFetch, getClienteToken } from '../utils/api';

const ClienteContext = createContext(null);

export function ClienteProvider({ children }) {
    const [cliente, setCliente] = useState(null);
    const [cargando, setCargando] = useState(true);

    // Intenta restaurar sesión al cargar la app
    useEffect(() => {
        const token = getClienteToken();
        if (!token) { setCargando(false); return; }
        clienteFetch(`${baseURL}/api/cliente/perfil`)
            .then(r => { if (!r.ok) throw new Error(); return r.json(); })
            .then(data => { if (data.cliente) setCliente(data.cliente); })
            .catch(() => {})
            .finally(() => setCargando(false));
    }, []);

    const login = async (telefono, contrasena) => {
        const res = await fetch(`${baseURL}/api/cliente/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ telefono, contrasena }),
        });
        const data = await res.json();
        if (data.token) setClienteToken(data.token);
        if (data.cliente) setCliente(data.cliente);
        return data;
    };

    const register = async (telefono, contrasena, nombre) => {
        const res = await fetch(`${baseURL}/api/cliente/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ telefono, contrasena, nombre }),
        });
        const data = await res.json();
        if (data.token) setClienteToken(data.token);
        if (data.cliente) setCliente(data.cliente);
        return data;
    };

    const logout = async () => {
        await clienteFetch(`${baseURL}/api/cliente/logout`, { method: 'POST' });
        clearClienteToken();
        setCliente(null);
    };

    return (
        <ClienteContext.Provider value={{ cliente, cargando, login, register, logout, setCliente }}>
            {children}
        </ClienteContext.Provider>
    );
}

export function useCliente() {
    return useContext(ClienteContext);
}
